import { render, staticRenderFns } from "./growthShare.vue?vue&type=template&id=6cc52484&scoped=true"
import script from "./growthShare.vue?vue&type=script&lang=js"
export * from "./growthShare.vue?vue&type=script&lang=js"
import style0 from "./growthShare.vue?vue&type=style&index=0&id=6cc52484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc52484",
  null
  
)

export default component.exports